import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function PurchaseOrderPaymentFailedBubble({
  history
}: PaymentBubbleCommonProps) {
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble error>
      <PaymentBubble.Title>입금 기간이 만료되었습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={1} />
      <PaymentBubble.Content>
        프로젝트가 결제/발주 단계에서 중단됩니다. 거래를 계속 진행하고 싶다면
        파트너에게 발주서를 재발행하세요.
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
